import React, { useState } from 'react';
import { useRouter } from 'next/router';

import './CoursesInsurance.scss';
import { getString } from '../../helpers/styles';
import icons from '../../shared/assets/icons/redesign';
import { trackAction, usePlatform } from '../../helpers/tracking';

const { Check, Logo } = icons;

export default function CoursesInsurance({
  isLogged,
  tracking,
  giveConsent,
  insurerList,
  nextButtonLink,
  changeUserData,
  userInsurerXuid
}) {
  const router = useRouter();
  const platform = usePlatform();
  const [checked, setChecked] = useState(false);
  const [selectedInsurer, setSelectedUnsurer] = useState(userInsurerXuid);

  const list = [...insurerList].sort((a, b) =>
    a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1
  );

  list.push(
    list.splice(
      list.findIndex(({ displayName }) => displayName === 'Overig'),
      1
    )[0]
  );

  return (
    <div className="coursesInsurance">
      <div className="coursesInsurance-header">
        <Logo />

        <span
          className="coursesInsurance-close-icon"
          onClick={() => {
            router.push(
              '/zwangerschapscursus/welkom?dimension5=ZP&dimension4=site&dimension6=wizzard&dimension7=wizzard'
            );

            trackAction(
              platform,
              'coursesbetalenverzekering',
              'clickclosebutton'
            );
          }}
        >
          &times;
        </span>
      </div>

      <h3 className="coursesInsurance-title">Kies je zorgverzekeraar</h3>

      <ul className="coursesInsurance-list">
        {list.map(({ xuid, logoUrl, displayName }) => (
          <li
            key={xuid}
            className={getString([
              {
                value: 'coursesInsurance-list-item',
                condition: true
              },
              {
                value: 'coursesInsurance-list-item-active',
                condition: selectedInsurer === xuid
              }
            ])}
            onClick={() => {
              setSelectedUnsurer(xuid);

              trackAction(
                platform,
                'coursesbetalenverzekering',
                'clickinsuranceprovider'
              );
            }}
          >
            <div>
              <img
                className="coursesInsurance-insurer-logo"
                src={logoUrl}
                width={50}
                height={50}
                alt="insurer-logo"
              />

              <p className="coursesInsurance-insurer-name">{displayName}</p>
            </div>

            <div className="coursesInsurance-item-checkbox-wrap">
              <span className="coursesInsurance-item-checkmark-wrap">
                <span className="coursesInsurance-item-checkmark">
                  <Check className="coursesInsurance-item-checkmark-icon" />
                </span>
              </span>
            </div>
          </li>
        ))}
      </ul>

      <div className="coursesInsurance-footer">
        {giveConsent && (
          <div
            className={getString([
              {
                value: 'courses-checkbox',
                condition: true
              },
              {
                value: 'courses-checkbox-checked',
                condition: checked
              }
            ])}
            onClick={() => {
              setChecked(!checked);
            }}
          >
            <span className="courses-checkmark">
              <Check className="courses-checkmark-content" />
            </span>

            <p className="coursesInsurance-footer-text">
              zwangerenportaal.nl mag mijn keuze opslaan om mij{' '}
              <a
                target="_blank"
                className="coursesInsurance-footer-link"
                href="/privacyverklaring"
              >
                een aanbieding
              </a>{' '}
              te doen.
            </p>
          </div>
        )}

        <button
          className={getString([
            {
              value: 'coursesInsurance-button',
              condition: true
            },
            {
              value: 'coursesInsurance-button-disabled',
              condition: !selectedInsurer
            }
          ])}
          onClick={async () => {
            if (!selectedInsurer) return;

            if (checked && isLogged) {
              giveConsent({
                variables: {
                  consentTypeCode: 'user-terms-and-condition',
                  counterparty: 'zwangerenportaal'
                }
              });

              giveConsent({
                variables: {
                  consentTypeCode: 'user-insure-marketing',
                  counterparty: 'zwangerenportaal'
                }
              });
            }

            if (tracking) trackAction(platform, ...tracking);

            if (isLogged)
              await changeUserData({
                variables: { insurerXuid: selectedInsurer }
              });

            const insurer = insurerList.find(
              ({ xuid }) => xuid === selectedInsurer
            );

            if (nextButtonLink) return router.push(nextButtonLink);

            location.href = insurer.policies.length
              ? `/verzekering/cursus-vergoeding-aanvullend?insurer=${insurer.xuid}`
              : `/verzekering/cursus-vergoeding/${encodeURIComponent(
                  insurer.displayName
                )}`;
          }}
        >
          Verder
        </button>
      </div>
    </div>
  );
}
